import { API_URL } from "constant"
import {REACT_APP_API_HOST as API_HOST} from "envs"
import { WebComponentMemory } from "views";


export const generateDocumentUrl = (documentId: string) => {
    const host = API_HOST ?? WebComponentMemory.host;
    return `${host}${API_URL.DOCUMENT_URL}/${documentId}`
}